<template>
    <section class="wrap-billet-content">
        <div class="row">
            <div class="small-12 medium-12 large-12 medium-centered columns">
                <h2>Olá {{ nome }},</h2>
                <p>Seguem os boletos disponíveis em nosso sitema.</p>

                <table>
                    <tbody>
                        <tr>
                            <th style="width:50%;">Nome</th>
                            <th style="width:50%;">Endereço</th>
                            <th>Vencimento</th>
                            <th>Valor</th>
                            <th>Mês/Ano</th>
                            <th></th>
                            <th></th>
                            <th v-if="banner_popup!=''"></th>
                            <th v-if="popup_simulacao==1"></th>
                        </tr>

                        <SearchResultItem @atualizarVencimento="atualizarVencimento" :popup_simulacao="popup_simulacao" :banner_popup="banner_popup" :boleto="boleto" v-for="boleto in boletos" :key="boleto.codigo"></SearchResultItem>
                    </tbody>
                </table>

                <p>
                    <i>
                        Caso esta seja a SEGUNDA VIA do seu boleto é necessário que após a geração do mesmo você aguarde uma hora para efetuar o pagamento,
                        pois o boleto precisa ser registrado junto ao banco.
                    </i>
                </p>
            </div>
        </div>
    </section>
</template>
<script>
import SearchResultItem from './SearchResultItem.vue';
export default {
    props: ['boletos', 'banner_popup', 'popup_simulacao'],
    components: {
        SearchResultItem
    },
    computed: {
        nome() {
            let [boleto] = this.boletos;
            return boleto.nome;
        }
    },
    methods: {
        atualizarVencimento() {
            this.$emit('atualizarVencimento');
        }
    }
}
</script>